import { random } from 'lodash'

import CSSPlugin from 'gsapAlias/CSSPlugin'
import TimelineLite from 'gsapAlias/TimelineLite'

// eslint-disable-next-line no-unused-vars
const plugins = [CSSPlugin]

export const shuffleSquaresAnim = params => {
  const allSquares = params.wrapper.children
  const timings = [0, 100, 200, 300, 400]

  let visibleSquaresIdx = [],
    photoSquaresIndexes = []

  const loopSquaresArray = () => {
    let squareIndexes = allSquares.length
      ? [...Array(allSquares.length).keys()]
      : []

    if (visibleSquaresIdx.length) {
      visibleSquaresIdx = visibleSquaresIdx.slice(5)
      squareIndexes = squareIndexes.filter(
        elem => !visibleSquaresIdx.includes(elem),
      )
    }

    if (squareIndexes.length) {
      while (visibleSquaresIdx.length < 10) {
        const index = random(0, squareIndexes.length - 1)

        visibleSquaresIdx.push(squareIndexes[index])
        squareIndexes.splice(index, 1)
      }
    }

    if (params.images) {
      let photosIndexes = params.images.length
        ? [...Array(params.images.length).keys()]
        : []

      if (photoSquaresIndexes.length) {
        photosIndexes = photosIndexes.filter(
          elem => !photoSquaresIndexes.includes(elem),
        )
        photoSquaresIndexes = photoSquaresIndexes.slice(3)
      }

      if (photosIndexes.length) {
        while (photoSquaresIndexes.length < 6) {
          const index = random(0, photosIndexes.length - 1)
          const photoIndex = photosIndexes[index]

          photoSquaresIndexes.push(photoIndex)
          photosIndexes.splice(index, 1)
        }
      }
    }
  }

  loopSquaresArray()

  const shuffleSquaresTl = new TimelineLite({
    onComplete: function() {
      this.timeoutId = setTimeout(
        () => shuffleSquaresAnimation(visibleSquaresIdx),
        2000,
      )
    },
  })

  const shuffleSquaresAnimation = squares => {
    loopSquaresArray()
    shuffleSquaresTl
      .to(
        allSquares[squares[0]],
        0,
        { autoAlpha: 0, backgroundImage: '' },
        `+=${timings[0] / 1000}`,
      )
      .to(allSquares[squares[5]], 0, {
        autoAlpha: 1,
        backgroundImage: photoSquaresIndexes.length
          ? `url(${params.images[photoSquaresIndexes[0]]})`
          : '',
      })
      .to(
        allSquares[squares[1]],
        0,
        { autoAlpha: 0, backgroundImage: '' },
        `+=${timings[1] / 1000}`,
      )
      .to(allSquares[squares[6]], 0, { autoAlpha: 1 })
      .to(
        allSquares[squares[2]],
        0,
        { autoAlpha: 0, backgroundImage: '' },
        `+=${timings[2] / 1000}`,
      )
      .to(allSquares[squares[7]], 0, {
        autoAlpha: 1,
        backgroundImage: photoSquaresIndexes.length
          ? `url(${params.images[photoSquaresIndexes[1]]})`
          : '',
      })
      .to(
        allSquares[squares[3]],
        0,
        { autoAlpha: 0, backgroundImage: '' },
        `+=${timings[3] / 1000}`,
      )
      .to(allSquares[squares[8]], 0, { autoAlpha: 1 })
      .to(
        allSquares[squares[4]],
        0,
        { autoAlpha: 0, backgroundImage: '' },
        `+=${timings[4] / 1000}`,
      )
      .to(allSquares[squares[9]], 0, {
        autoAlpha: 1,
        backgroundImage: photoSquaresIndexes.length
          ? `url(${params.images[photoSquaresIndexes[2]]})`
          : '',
      })
  }

  return shuffleSquaresTl
}
